export default {
      id: "ic_mute_user_hidden-usage",
      viewBox: "0 0 24 24",
      url: "/" + "images/icons.3.109.2.svg#ic_mute_user_hidden-usage",
      toString: function () {
        return this.url;
      }
    }